import React from "react"

function Quote({ children, citation, imageSource, alt }) {
  if (imageSource) {
    return (
      <div className="container quote-alt">
        <div className="row">
          <div className="four columns">
            <img src={imageSource} alt={citation} />
          </div>
          <div className="eight columns">
            <h3>“{children}”</h3>
            <p>{citation}</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container quote">
      <div className="row">
        <h3>“{children}”</h3>
        <p>{citation}</p>
      </div>
    </div>
  )
}

export default Quote
